var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-array-index-key: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import Icon from 'react-svg-ikon';
import { TSS_BLACK, TSS_DARK_BLUE, TSS_BLUE_1, TSS_GRAY, TSS_BLUE, keyCode } from 'tss-core-lib-common';
import { IconButton } from './buttons';
import { IMG_ICON_CROSS_SMALL } from '../img';

var styles = void 0;

var TagInput = function (_Component) {
  _inherits(TagInput, _Component);

  function TagInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TagInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagInput.__proto__ || Object.getPrototypeOf(TagInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _this.addNewValue = function () {
      var value = _this.state.value;

      var used = false;
      if (!_this.props.allowDuplicates) {
        used = _this.props.value.indexOf(value) >= 0;
      }
      _this.setState({ value: '' });
      if (_this.props.onChange && _this.props.value.length <= _this.props.maxTags - 1 && !used) {
        _this.props.onChange([].concat(_toConsumableArray(_this.props.value), [_this.props.trim ? value.trim() : value]));
      }
    }, _this.handleRemoveTag = function (index) {
      return _this.props.onChange && _this.props.onChange([].concat(_toConsumableArray(_this.props.value.slice(0, index)), _toConsumableArray(_this.props.value.slice(index + 1))));
    }, _this.handleInputChange = function (event) {
      var value = event.target.value;
      value = _this.props.upperCase ? value.toUpperCase() : value;
      if (value.length <= _this.props.maxLength) {
        _this.setState({ value: value });
      }
    }, _this.handleKeyDown = function (event) {
      if (!_this.props.allowSpace && event.which === keyCode.SPACE || event.which === keyCode.ENTER) {
        _this.addNewValue();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TagInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: css(styles.container) },
        React.createElement(
          'div',
          { className: css(styles.tagList, this.props.disabled && styles.tagListDisabled) },
          this.props.value.map(function (tag, index) {
            return React.createElement(
              'div',
              { key: tag + '-' + index, className: css(styles.tag, _this2.props.upperCase && styles.upperCase) },
              tag,
              React.createElement(
                IconButton,
                { style: styles.removeTagButton, onClick: function onClick() {
                    return _this2.handleRemoveTag(index);
                  } },
                React.createElement(Icon, { src: IMG_ICON_CROSS_SMALL, color: TSS_BLACK() })
              )
            );
          })
        ),
        React.createElement('input', {
          value: this.state.value,
          type: 'text',
          className: css(styles.input, this.props.upperCase && styles.upperCase),
          onChange: this.handleInputChange,
          onKeyDown: this.handleKeyDown,
          disabled: this.props.disabled
        }),
        this.state.value.length ? React.createElement(
          'div',
          { className: css(styles.dropdownItem, this.props.upperCase && styles.upperCase), role: 'button', tabIndex: -1, onClick: this.addNewValue },
          this.state.value
        ) : null
      );
    }
  }]);

  return TagInput;
}(Component);

TagInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  allowSpace: PropTypes.bool,
  maxLength: PropTypes.number,
  maxTags: PropTypes.number,
  allowDuplicates: PropTypes.bool,
  upperCase: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  trim: PropTypes.bool
};
TagInput.defaultProps = {
  value: [],
  allowSpace: true,
  maxLength: 30,
  maxTags: 5,
  allowDuplicates: false,
  upperCase: false,
  onChange: null,
  disabled: false,
  trim: true
};


styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: '4.8rem',
    border: '2px solid ' + TSS_BLUE_1(),
    backgroundColor: 'white'
  },

  tagList: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '0.3rem'
  },
  tagListDisabled: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '0rem'
  },

  tag: {
    border: '1px solid ' + TSS_DARK_BLUE(0.5),
    borderRadius: 4,
    padding: '0.5rem',
    fontSize: '1.4rem',
    display: 'flex',
    alignItems: 'center',
    color: TSS_BLACK(),
    backgroundColor: TSS_DARK_BLUE(0.05),
    margin: '0.2rem',
    maxHeight: '3rem'
  },

  input: {
    flex: '1 0 50%',
    minWidth: '20rem',
    border: 0,
    fontSize: '1.4rem',
    outline: 0,
    padding: '0 0 0 1rem',
    margin: 0,
    ':focus': {
      borderColor: TSS_GRAY()
    },
    minHeight: '4.4rem'
  },

  removeTagButton: {
    marginLeft: '0.5rem'
  },

  dropdownItem: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    marginTop: 1,
    backgroundColor: TSS_BLUE(),
    color: TSS_BLACK(),
    fontWeight: 500,
    fontSize: '1.4rem',
    padding: '1.3rem 1.6rem',
    cursor: 'pointer'
  },
  upperCase: {
    textTransform: 'uppercase'
  }
});

export default TagInput;